export function PageHeader({ title, description, right }) {
  return (
    <div className="flex items-start justify-between gap-6 mb-10">
      <div>
        <h1 className="font-display text-3xl md:text-4xl font-black uppercase tracking-tight">{title}</h1>
        {description && <p className="text-sm text-zinc-400 mt-2 max-w-2xl">{description}</p>}
      </div>
      {right}
    </div>
  );
}

export function Button({ as: As = "button", variant = "primary", className = "", children, ...p }) {
  const base = "inline-flex items-center justify-center gap-2 font-bold uppercase tracking-wider text-xs px-5 py-2.5 transition-all disabled:opacity-50";
  const v = {
    primary: "bg-[#FF4F00] hover:bg-[#E64700] text-black hover:-translate-y-0.5",
    secondary: "border border-white/20 hover:border-white/60 hover:bg-white/5 text-white",
    danger: "border border-red-500/40 hover:border-red-400 hover:bg-red-500/10 text-red-300",
    ghost: "text-zinc-400 hover:text-white",
  }[variant];
  return <As className={`${base} ${v} ${className}`} {...p}>{children}</As>;
}

export function TextInput({ label, testid, className = "", ...p }) {
  return (
    <label className="block">
      {label && <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500 mb-2 block">{label}</span>}
      <input
        data-testid={testid}
        className={`w-full bg-surface-1 border border-white/10 text-white placeholder:text-zinc-500 focus:border-[#FF4F00] focus:outline-none font-mono text-sm h-11 px-3 ${className}`}
        {...p}
      />
    </label>
  );
}

export function TextArea({ label, testid, rows = 4, className = "", ...p }) {
  return (
    <label className="block">
      {label && <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500 mb-2 block">{label}</span>}
      <textarea
        rows={rows}
        data-testid={testid}
        className={`w-full bg-surface-1 border border-white/10 text-white placeholder:text-zinc-500 focus:border-[#FF4F00] focus:outline-none font-mono text-sm px-3 py-2.5 ${className}`}
        {...p}
      />
    </label>
  );
}

export function Card({ children, className = "" }) {
  return <div className={`border border-white/10 bg-surface-2 ${className}`}>{children}</div>;
}

export function Toggle({ checked, onChange, label, testid }) {
  return (
    <button
      type="button"
      data-testid={testid}
      onClick={() => onChange(!checked)}
      className="flex items-center gap-3"
    >
      <span className={`w-9 h-5 rounded-full relative transition-colors ${checked ? "bg-[#FF4F00]" : "bg-white/10"}`}>
        <span className={`absolute top-0.5 w-4 h-4 bg-black transition-transform ${checked ? "translate-x-[18px]" : "translate-x-0.5"}`} />
      </span>
      {label && <span className="font-mono text-[11px] uppercase tracking-[0.15em] text-zinc-300">{label}</span>}
    </button>
  );
}

export function EmptyState({ message = "Henüz kayıt yok." }) {
  return (
    <div className="border border-dashed border-white/10 bg-surface-2 p-10 text-center font-mono text-xs uppercase tracking-[0.2em] text-zinc-500">
      {message}
    </div>
  );
}
